"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HelperUtils_1 = require("utils/HelperUtils");
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const TooltipContainer = ({ tooltipClass = '', backgroundClassname = 'bg-n-900', show, text, children, classContainer = '', position = 'top', align = 'middle', onClick, dataCy, customStyle, wrap = false, dataCyTooltip, useMaxWidth = true, textChangeable = false, callbackRef, tooltipContent, useMousePosition, isPassPropsToChildren, disableStack // use this props if you don't want the current tooltip to appear with another tooltip so it would be hidden and keep another tooltip appear
 }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const clientRect = (0, react_1.useRef)(null);
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const showRef = (0, react_1.useRef)(show);
    const timeoutId = (0, react_1.useRef)(null);
    const tooltipId = (0, uuid_1.v4)();
    const localizedText = (0, HelperUtils_1.getObjectiveLocale)(text);
    const setPortal = ({ top, left }) => {
        if (!showRef.current)
            return;
        const rect = clientRect.current?.getBoundingClientRect();
        setIsTooltipShown(true);
        const portalData = {
            name: localizedText,
            noWrap: !wrap
        };
        tooltipContent && (portalData.tooltipContent = tooltipContent());
        if (rect) {
            switch (align) {
                case 'left':
                    portalData.left = rect?.left;
                    break;
                case 'middle':
                    portalData.left = rect?.left + rect?.width / 2;
                    portalData.translateX = '-50%';
                    break;
                case 'right':
                    portalData.left = rect?.right;
                    portalData.translateX = '-100%';
                    break;
            }
            switch (position) {
                case 'top':
                    portalData.top = rect?.top - 8;
                    portalData.translateY = '-100%';
                    break;
                case 'bottom':
                    portalData.top = rect?.bottom + 8;
                    break;
            }
        }
        if (useMousePosition) {
            portalData.left = left;
            portalData.top = top;
        }
        setPortalData(portalData);
    };
    const handleRef = (ref) => {
        clientRect.current = ref;
        callbackRef && callbackRef(ref);
    };
    const onMouseEnter = (e) => {
        const clientX = e.clientX;
        const clientY = e.clientY;
        timeoutId.current = setTimeout(() => {
            setPortal({ top: clientY, left: clientX });
        }, 500);
    };
    const onMouseLeave = () => {
        setIsTooltipShown(false);
        timeoutId?.current && clearTimeout(timeoutId.current);
    };
    (0, react_1.useEffect)(() => {
        if (textChangeable && isTooltipShown) {
            setPortalData((data) => {
                return {
                    ...data,
                    name: text
                };
            });
        }
    }, [text, setPortalData, isTooltipShown, textChangeable]);
    (0, react_1.useEffect)(() => {
        !show && onMouseLeave();
    }, [show]);
    (0, react_1.useEffect)(() => {
        showRef.current = show;
    }, [show]);
    (0, react_1.useEffect)(() => {
        if (!disableStack)
            return;
        const sharedTooltip = document.getElementById(`shared-tooltip`);
        if (!sharedTooltip)
            return;
        const observer = new MutationObserver((mutationList) => {
            mutationList.forEach(function (mutation) {
                const currentTooltip = document.getElementById(tooltipId);
                if (mutation.type != 'childList')
                    return;
                if (sharedTooltip.children.length > 1) {
                    currentTooltip?.classList.add('hidden');
                    return;
                }
                currentTooltip?.classList.remove('hidden');
            });
        });
        observer.observe(sharedTooltip, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, [tooltipId, disableStack]);
    const propsElement = {
        className: classContainer,
        ref: (ref) => ref && handleRef(ref),
        onMouseEnter: (e) => onMouseEnter(e),
        onMouseLeave,
        onPointerLeave: onMouseLeave,
        'data-cy': dataCy,
        onClick,
        style: customStyle
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: "shared-tooltip", className: `${tooltipClass} ${useMaxWidth ? 'max-w-[240px]' : ''}`, dataCy: dataCyTooltip, tooltipId: tooltipId, backgroundClassname: backgroundClassname }),
        isPassPropsToChildren && react_1.default.isValidElement(children) ? (react_1.default.cloneElement(children, { ...propsElement })) : (react_1.default.createElement("div", { ...propsElement }, children))));
};
exports.default = TooltipContainer;
